import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import useCompanies from '../../../../queries/useCompanies';
import useTransportPermitsMatch from './useTransportPermitsMatch';
import { useEffect, useMemo } from 'react';
import {
  getCompanyFromUrlOrSavedOrFirst,
  saveSelectedCompanyId,
} from '../../../../helpers/companyStorage';
import { links } from '../constants/links';

const useCompanyInitialization = () => {
  const match = useTransportPermitsMatch();
  const history = useHistory();
  const { data: companies, isLoading } = useCompanies({ placeholderData: [] });

  const urlCompanyId = match?.params.companyId
    ? Number(match.params.companyId)
    : null;


  const targetCompany = useMemo(() => {
    if (!companies?.length) return null;
    return getCompanyFromUrlOrSavedOrFirst(companies, urlCompanyId);
  }, [companies, urlCompanyId]);

  useEffect(() => {
    if (targetCompany && companies?.length) {
      const currentUrlCompanyId = match?.params.companyId
        ? Number(match.params.companyId)
        : null;

      if (currentUrlCompanyId !== targetCompany.id) {
        const page = match?.params.page || links.transports;
        history.replace({
          pathname: `${links.rootWithCompany}/${targetCompany.id}/${page}`,
        });
      }

      saveSelectedCompanyId(targetCompany.id);
    }
  }, [targetCompany, companies, match, history]);

  return {
    companyId: targetCompany?.id || null,
    company: targetCompany,
    isLoading: isLoading || !companies?.length,
  };
};

export default useCompanyInitialization;
